'use strict';

exports.__esModule = true;
exports.default = MessengerCheckbox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessengerCheckbox(props) {
  var className = props.className,
      origin = props.origin,
      prechecked = props.prechecked,
      allowLogin = props.allowLogin,
      userRef = props.userRef,
      messengerAppId = props.messengerAppId,
      pageId = props.pageId,
      children = props.children,
      size = props.size,
      onParse = props.onParse,
      centerAlign = props.centerAlign,
      skin = props.skin;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-messenger-checkbox',
        messenger_app_id: messengerAppId,
        page_id: pageId,
        size: size,
        origin: origin,
        user_ref: userRef,
        prechecked: prechecked,
        allow_login: allowLogin,
        skin: skin,
        center_align: centerAlign
      },
      children
    )
  );
}

MessengerCheckbox.defaultProps = {
  size: undefined,
  allowLogin: undefined,
  prechecked: undefined,
  userRef: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined,
  origin: undefined,
  skin: undefined,
  centerAlign: undefined
};
//# sourceMappingURL=MessengerCheckbox.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/MessengerCheckbox.js
// module id = 716
// module chunks = 198517197184460